"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: txactivity/activity-view.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Ftxactivity%2Factivity-view.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityTransferRequest = exports.HelpCenterArticle = exports.CounterpartyView = exports.ActivityView = void 0;
const alias_1 = require("../common/alias");
const amount_1 = require("../common/amount");
const activity_details_1 = require("./activity-details");
const activity_preview_1 = require("./activity-preview");
const protobufPackage = 'com.step.txactivity.proto';
function createBaseActivityView() {
    return {
        id: '',
        paymentId: '',
        amount: amount_1.Amount.fromPartial({}),
        timeMs: '0',
        isPending: false,
        preview: activity_preview_1.ActivityPreview.fromPartial({}),
        details: activity_details_1.ActivityDetails.fromPartial({}),
        counterparty: undefined,
        related: [],
        article: undefined,
        transferRequest: undefined,
    };
}
exports.ActivityView = {
    fromJSON(object) {
        const message = {
            id: isSet(object.id) ? globalThis.String(object.id) : '',
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
            timeMs: isSet(object.timeMs) ? globalThis.String(object.timeMs) : '0',
            preview: isSet(object.preview)
                ? activity_preview_1.ActivityPreview.fromJSON(object.preview)
                : activity_preview_1.ActivityPreview.fromPartial({}),
            details: isSet(object.details)
                ? activity_details_1.ActivityDetails.fromJSON(object.details)
                : activity_details_1.ActivityDetails.fromPartial({}),
            related: globalThis.Array.isArray(object?.related)
                ? object.related.map((e) => exports.ActivityView.fromJSON(e))
                : [],
        };
        if (isSet(object.paymentId)) {
            message.paymentId = globalThis.String(object.paymentId);
        }
        if (isSet(object.isPending)) {
            message.isPending = globalThis.Boolean(object.isPending);
        }
        if (isSet(object.counterparty)) {
            message.counterparty = exports.CounterpartyView.fromJSON(object.counterparty);
        }
        if (isSet(object.article)) {
            message.article = exports.HelpCenterArticle.fromJSON(object.article);
        }
        if (isSet(object.transferRequest)) {
            message.transferRequest = exports.ActivityTransferRequest.fromJSON(object.transferRequest);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.paymentId !== undefined && message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.timeMs !== '0') {
            obj.timeMs = message.timeMs;
        }
        if (message.isPending !== undefined && message.isPending !== false) {
            obj.isPending = message.isPending;
        }
        if (message.preview !== undefined) {
            obj.preview = activity_preview_1.ActivityPreview.toJSON(message.preview);
        }
        if (message.details !== undefined) {
            obj.details = activity_details_1.ActivityDetails.toJSON(message.details);
        }
        if (message.counterparty !== undefined) {
            obj.counterparty = exports.CounterpartyView.toJSON(message.counterparty);
        }
        if (message.related?.length) {
            obj.related = message.related.map((e) => exports.ActivityView.toJSON(e));
        }
        if (message.article !== undefined) {
            obj.article = exports.HelpCenterArticle.toJSON(message.article);
        }
        if (message.transferRequest !== undefined) {
            obj.transferRequest = exports.ActivityTransferRequest.toJSON(message.transferRequest);
        }
        return obj;
    },
    create(base) {
        return exports.ActivityView.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseActivityView();
        message.id = object.id ?? '';
        message.paymentId = object.paymentId ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.timeMs = object.timeMs ?? '0';
        message.isPending = object.isPending ?? false;
        message.preview = (object.preview !== undefined && object.preview !== null)
            ? activity_preview_1.ActivityPreview.fromPartial(object.preview)
            : activity_preview_1.ActivityPreview.fromPartial({});
        message.details = (object.details !== undefined && object.details !== null)
            ? activity_details_1.ActivityDetails.fromPartial(object.details)
            : activity_details_1.ActivityDetails.fromPartial({});
        message.counterparty = (object.counterparty !== undefined && object.counterparty !== null)
            ? exports.CounterpartyView.fromPartial(object.counterparty)
            : undefined;
        message.related = object.related?.map((e) => exports.ActivityView.fromPartial(e)) || [];
        message.article = (object.article !== undefined && object.article !== null)
            ? exports.HelpCenterArticle.fromPartial(object.article)
            : undefined;
        message.transferRequest =
            (object.transferRequest !== undefined && object.transferRequest !== null)
                ? exports.ActivityTransferRequest.fromPartial(object.transferRequest)
                : undefined;
        return message;
    },
};
function createBaseCounterpartyView() {
    return { userId: '', aliases: [], name: '' };
}
exports.CounterpartyView = {
    fromJSON(object) {
        const message = {
            aliases: globalThis.Array.isArray(object?.aliases)
                ? object.aliases.map((e) => alias_1.Alias.fromJSON(e))
                : [],
        };
        if (isSet(object.userId)) {
            message.userId = globalThis.String(object.userId);
        }
        if (isSet(object.name)) {
            message.name = globalThis.String(object.name);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== undefined && message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.aliases?.length) {
            obj.aliases = message.aliases.map((e) => alias_1.Alias.toJSON(e));
        }
        if (message.name !== undefined && message.name !== '') {
            obj.name = message.name;
        }
        return obj;
    },
    create(base) {
        return exports.CounterpartyView.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCounterpartyView();
        message.userId = object.userId ?? '';
        message.aliases = object.aliases?.map((e) => alias_1.Alias.fromPartial(e)) || [];
        message.name = object.name ?? '';
        return message;
    },
};
function createBaseHelpCenterArticle() {
    return { articleId: '', collectionId: '' };
}
exports.HelpCenterArticle = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.articleId)) {
            message.articleId = globalThis.String(object.articleId);
        }
        if (isSet(object.collectionId)) {
            message.collectionId = globalThis.String(object.collectionId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.articleId !== undefined && message.articleId !== '') {
            obj.articleId = message.articleId;
        }
        if (message.collectionId !== undefined && message.collectionId !== '') {
            obj.collectionId = message.collectionId;
        }
        return obj;
    },
    create(base) {
        return exports.HelpCenterArticle.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseHelpCenterArticle();
        message.articleId = object.articleId ?? '';
        message.collectionId = object.collectionId ?? '';
        return message;
    },
};
function createBaseActivityTransferRequest() {
    return { id: '' };
}
exports.ActivityTransferRequest = {
    fromJSON(object) {
        const message = {
            id: isSet(object.id) ? globalThis.String(object.id) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        return obj;
    },
    create(base) {
        return exports.ActivityTransferRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseActivityTransferRequest();
        message.id = object.id ?? '';
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=activity-view.js.map